export const OrderStatus = {
    new: "New",
    processing: "Processing",
    confirmed: "Confirmed",
    pending_payment: "Pending Payment",
    payment_failed: "Payment failed",
    payment_completed: "Payment completed",
    shipped: "Shipped",
    shipped_to_warehouse: "Shipped to warehouse",
    delivered: "Delivered",
    on_hold: "On Hold",
    delivered_to_pick_up_point: "Delivered To Pickup Point",
    pending: "Pending",
    pending_cancellation: "Pending cancellation",
    canceled: "Canceled",
    returned: "Returned",
    complete: "Complete",
};
//# sourceMappingURL=Order.js.map